export function formatDateString(dateString: string): string {
    const date = new Date(dateString);

    // Arrays of weekdays and months
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Extract local day of the week, day of the month, and month
    const dayOfWeek = weekdays[date.getDay()];
    const dayOfMonth = date.getDate();
    const month = months[date.getMonth()];

    // Extract local hours and minutes
    let hours = date.getHours();
    const minutes = date.getMinutes();

    // Determine AM or PM
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert '0' to '12'

    // Format minutes to always be two digits
    const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

    // Construct the formatted string
    return `${dayOfWeek}, ${month} ${dayOfMonth} at ${hours}:${minutesFormatted} ${ampm}`;
}
